import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import DateModelField from '@shared/fields/date-model-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import { TeamField } from '@modules/team/team-field';
import ImagesField from '@shared/fields/images-field';
import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';
import { ProgramField } from '@modules/program/program-field';
import { SubprogramField } from '@modules/subprogram/subprogram-field';
import BooleanField from '@shared/fields/boolean-field';

function getPathPicture(subpropertyId, playerId){
    return `subproperties/${subpropertyId}/players/${playerId}/picture`
}

function label(name) {
    return i18n(`entities.player.fields.${name}`);
}

const fields = ({ dateFormat, timeFormat }) => ({
    id: new IdField('id', label('id')),
    team: new StringField('team', label('team')),
    teams: TeamField.relationToMany('teams', label('teams'), {}),
    firstName: new StringField('firstName', label('firstName'), { "required": true }),
    lastName: new StringField('lastName', label('lastName'), { "required": true }),
    birthdate: new DateModelField('birthdate', label('birthdate'), { "required": true, dateFormat }),
    isMember: new BooleanField('isMember', label('isMember'), { "required": true }),
    careerInfo: new StringField('careerInfo', label('careerInfo'), { required: true }),
    picture: new ImagesField('picture', label('picture'), (subpropertyId, playerId) => getPathPicture(subpropertyId, playerId), { "required": true, "max": 1 }),
    gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('gender'), { required: true }),
    country: new EnumeratorField('country', label('country'), getSharedEnumeratorField('country'), { required: true }),
    program: ProgramField.relationToOne('program', label('program'), { "required": true, }),
    subprogram: SubprogramField.relationToOne('subprogram', label('subprogram'), { "required": true, }),
    birthdateRange: new DateTimeRangeField('birthdateRange', label('birthdateRange')),
    lastLogin: new DateTimeField('lastLogin', label('lastLogin'), { dateFormat, timeFormat }),
    createdAt: new DateTimeField('createdAt', label('createdAt'), { dateFormat, timeFormat }),
    updatedAt: new DateTimeField('updatedAt', label('updatedAt'), { dateFormat, timeFormat }),
    createdAtRange: new DateTimeRangeField('createdAtRange', label('createdAtRange')),
});

export class PlayerModel extends GenericModel {
    constructor({ dateFormat, timeFormat } = {}) {
        super();

        this.dateFormat = dateFormat;
        this.timeFormat = timeFormat;
    }

    fields() {
        const { dateFormat, timeFormat } = this;
        return fields({ dateFormat, timeFormat });
    }

    presenter(row, fieldName) {
        const fields = this.fields();

        if (!fields[fieldName]) {
            throw new Error(`${fieldName} not found`);
        }

        return fields[fieldName].forPresenter(
            row[fields[fieldName].name],
        );
    }
}